import SeoLandingPage from "@/components/SeoLandingPage";

const ApartmentTurnover = () => (
  <SeoLandingPage
    slug="apartment-turnover-wi"
    metaTitle="Apartment Turnover Wisconsin | 24-Hour Unit Turn for Landlords"
    metaDescription="Apartment turnover service in Wisconsin. Junk-out, deep clean coordination, and rent-ready in 24–48 hours. Trusted by property managers since 2018."
    h1="Apartment Turnovers for Wisconsin Property Managers"
    heroImage="/images/garage.jpg"
    heroIntro="Every day a unit sits empty is lost rent. We turn apartments, duplexes, and small multifamily units across Wisconsin in 24–48 hours so the next tenant can move in."
    serviceName="Apartment Turnover"
    bullets={[
      "Full junk-out of anything the previous tenant left behind.",
      "Appliance haul-away and replacement coordination.",
      "Carpet, vinyl, and damaged flooring removal.",
      "Paint, patch, and minor repair coordination through trusted subs.",
      "Move-out inspection photo set for security-deposit decisions.",
      "Volume pricing for property managers with 5+ units a month.",
    ]}
    whyUs={[
      "Specialists in Northeast Wisconsin multifamily — Green Bay, Appleton, Oshkosh, Fond du Lac.",
      "Predictable 24–48 hour turn so you can confirm move-in dates with confidence.",
      "Single invoice for cleanout + flooring + paint coordination.",
      "Volume discounts for property managers running 5+ turnovers a month.",
    ]}
    processSteps={[
      { title: "Tenant moves out", detail: "You hand us keys or a lockbox code. No need to be on-site." },
      { title: "Photo inspection", detail: "Full photo set within 4 hours of arrival, ready for your security-deposit documentation." },
      { title: "Turn the unit", detail: "Junk-out, flooring, paint, and clean coordinated as a single workstream." },
      { title: "Move-in ready", detail: "Final photos sent. Keys returned. Unit ready for the next tenant within 48 hours." },
    ]}
    faqs={[
      { q: "How fast can you turn a unit?", a: "Most 1- and 2-bedroom apartments in Wisconsin are turned within 24–48 hours of getting the keys. Larger units or heavy damage may take 3–5 days." },
      { q: "Do you offer volume pricing?", a: "Yes. Property managers running 5+ turnovers per month qualify for discounted per-unit pricing and a dedicated point of contact." },
      { q: "Can you coordinate flooring and paint?", a: "Yes. We have long-standing relationships with painters, flooring installers, and handymen across Northeast Wisconsin. One invoice, one project manager." },
      { q: "What about move-out photos for the security deposit?", a: "We deliver a full time-stamped photo set within 4 hours of arrival so you have documentation before any work begins." },
    ]}
    ctaHeadline="Cut your vacancy days in half."
  />
);

export default ApartmentTurnover;
